export enum ApiRoutesEmailNotifications {
  Recipients = "admin/email-notifications/recipients",
  AdminSuggestions = "admin/email-notifications/admin-suggestions"
}
